import { Injectable } from '@angular/core';
import * as tokenNotExpired from 'jwt-decode';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../common/Globals';
import { Router } from '@angular/router';

@Injectable()
export class AuthService {

    static isAuthenticated(): boolean {
        const token = localStorage.getItem('gesAuthToken');
        var getRememberMe = localStorage.getItem("rememberMe");
        if (getRememberMe == "true") {
            if (token !== 'null' && token !== '') {
                let expiresAt = tokenNotExpired(token)['exp'];
                expiresAt = new Date(expiresAt * 1000);
                if (expiresAt && (new Date() < expiresAt)) {
                    return true;
                }
            }
        }
        else {
            var loginTime = localStorage.getItem('loginTime');
            var parseLoginTime = new Date(loginTime);
            var oneHour = new Date();
            oneHour.setHours(oneHour.getHours() - 24);
            if (parseLoginTime > oneHour) {
                return true
            }
        }
        return false;
    }

    constructor(private httpClient: HttpClient,
        private router: Router) {

    }

    login(username: string, password: string) {
        return this.httpClient.post(Globals.webUrl + 'account/login', { username: username, password: password });
    }

    checkPasswordValidity(password: any) {
        return this.httpClient.post(Globals.webUrl + 'account/valid', password);
    }

    checkValidation() {
        var check = AuthService.isAuthenticated();
        if (check == false) {
            this.router.navigate(['/login']);
        }
    }

}
